module.exports = __webpack_public_path__ + "media/Puzzle_Game_Tech_PowerUp_Large_01.0fa900b0.wav";